import IStatusModel from "types/backend_models/lookup_status/IStatusModel";

export interface ICustomSelectOptionModel {
	value: string | number,
	label: string
}

export function statusToSelectModels(statusModels: IStatusModel[]): ICustomSelectOptionModel[] {
	let selectOptions: ICustomSelectOptionModel[] = [];
	selectOptions.push({ value: '', label: 'All' });
	statusModels.map(statusModel => statusToSelectModel(statusModel)).forEach(csm => {
		selectOptions.push(csm);
	});
	return selectOptions;
}

export function statusToSelectModel(statusModel: IStatusModel): ICustomSelectOptionModel {
	return {
		value: statusModel.id,
		label: statusModel.label
	}
}